import { CampaignAdGroupLocation } from '../types/Campaign';

const CampaignAdGroupLocationUtils = {
    toDspGeoLocationIds: (targets: CampaignAdGroupLocation[]): string[] => {
        return targets?.map((target: CampaignAdGroupLocation) => target.dspGeoLocationId) || [];
    },
};

export default CampaignAdGroupLocationUtils;
